<template>
    <div class="forget">
        <navTop :isLogin="1" title="相君科技平台忘记密码"></navTop>
        <div class="forget_all">
            <div class="forget_accent">
                <div class="forget_title">
                    忘记密码
                </div>
                <div class="forget_phone">
                    <el-input v-model="param.phone" placeholder="请输入手机号/邮箱"></el-input>
                </div>
                <div class="forget_code">
                    <el-input v-model="param.code" placeholder="请输入验证码"></el-input>
                    <button class="btn" @click="centerDialogVisible = true" :disabled="codeButt.status">
                        {{codeButt.text}}
                    </button>
                </div>
                <div class="forget_pass">
                    <!-- <el-input v-model="param.newpassWord" placeholder="请输入新密码"></el-input> -->
                    <el-form ref="login" :rules="rules" :model="param">
                        <el-form-item prop="newpassWord">
                            <el-input placeholder="请输入新密码" prefix-icon="el-icon-lock" v-model="param.newpassWord"
                                      clearable
                                      show-password>
                            </el-input>
                        </el-form-item>
                    </el-form>


                </div>
                <div class="forget_pass">
                    <el-input v-model="param.newpassWordAgin" placeholder="再次确定新密码" show-password></el-input>
                </div>
                <div class="aginBtn" @click="handlCheckSure">确认</div>
            </div>
        </div>

        <el-dialog title="短信验证码" :visible.sync="centerDialogVisible" width="30%" center id="phoneDialog">
            <div class="dialog_phone">
                手机号：{{param.phone}}
            </div>
            <div class="dialog_code">
                <el-input v-model="param.code" placeholder="请输入验证码"></el-input>
                <button class="btn" @click="handlCheckHuoQu" :disabled="codeButt.status">{{codeButt.text}}</button>
            </div>
            <div class="dialog_btn" @click="centerDialogVisible = false">确认</div>
        </el-dialog>

        <el-dialog title="身份验证" :visible.sync="userDialogVisible" width="30%" center id="userDialog">
            <div class="dialog_num">
                <div class="idCard">
                    <el-input v-model="idCard.one"></el-input>
                </div>
                <div class="idCard">
                    <el-input v-model="idCard.two"></el-input>
                </div>
                <div class="idCard">
                    <el-input v-model="idCard.three"></el-input>
                </div>
                <div class="idCard">
                    <el-input v-model="idCard.four"></el-input>
                </div>
            </div>
            <div class="dialog_text">
                请输入身份证后四位
            </div>
            <div class="dialog_btn" @click="userDialogVisible = false">确认</div>
        </el-dialog>

        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                param: {
                    phone: '',
                    code: '',
                    newpassWord: '',
                    newpassWordAgin: ''
                },
                idCard: {
                    one: '',
                    two: '',
                    three: '',
                    four: ''
                },
                centerDialogVisible: false,
                userDialogVisible: false,
                codeButt: {
                    text: '获取验证码',
                    status: false,
                    value: ''
                },
                rules: {
                    newpassWord: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度应大于等于6个字符小于16个字符!',
                            trigger: "blur"
                        },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
                                console.log(passwordreg.test(value))
                                if (!passwordreg.test(value)) {
                                    callback(new Error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                },
            }
        },
        methods: {
            handlCheckSure() {
                if (this.param.phone && this.param.code && this.param.newpassWord == this.param.newpassWordAgin) {
                    let _this = this;
                    _this.$refs.login.validate(valid => {
                        if (valid) {

                            let param = new URLSearchParams();
                            param.append("code", _this.param.code);
                            param.append("password", _this.param.newpassWordAgin);
                            param.append("username", _this.param.phone);

                            console.log(param)
                            _this.api.forgetAndUpdatePassword(param).then(res => {
                                console.log(res);
                                _this.$message.success("修改成功");
                                _this.$router.push({
                                    path: '/login'
                                })
                            })
                        }
                    })

                } else {
                    this.$message.error("信息有误");
                }
            },
            handlCheckHuoQu() {
                this.codeButt.status = true;
                let countdown = 60;
                let _this = this;
                if (_this.xm.isPhone(_this.param.phone)) {
                    let param = new URLSearchParams();
                    param.append('phone', _this.param.phone);
                    param.append('type', 3);

                    _this.api.sendCodeToPhone(param).then(res => {
                        console.log(res)
                        _this.$message.success("发送成功");
                        _this.codeButt.text = countdown + '秒';
                        _this.codeButt.status = true;
                        let timer = setInterval(() => {
                            if (countdown > 0) {
                                _this.codeButt.text = countdown - 1 + '秒';
                                countdown--;
                            } else {
                                clearInterval(timer);
                                _this.codeButt.text = '获取验证码';
                                _this.codeButt.status = false;
                            }
                        }, 1000);
                    })
                } else if (_this.xm.isEmail(_this.param.phone)) {
                    let param = new URLSearchParams();
                    param.append('email', _this.param.phone);
                    param.append('type', 2);
                    _this.api.sendCodeToEmail(param).then(res => {
                        console.log(res)
                        _this.$message.success("发送成功");
                        _this.codeButt.text = countdown + '秒';
                        _this.codeButt.status = true;
                        let timer = setInterval(() => {
                            if (countdown > 0) {
                                _this.codeButt.text = countdown - 1 + '秒';
                                countdown--;
                            } else {
                                clearInterval(timer);
                                _this.codeButt.text = '获取验证码';
                                _this.codeButt.status = false;
                            }
                        }, 1000);
                    })
                } else {
                    this.codeButt.status = false;
                }

            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    /deep/ .el-input__inner {
        height: 60px;
        line-height: 60px;
    }

    /deep/ .el-dialog--center {
        border-radius: 30px;
    }

    #userDialog .dialog_num {
        width: @a;
        height: 60px;
        display: @flex;

        .idCard {
            width: 115px;
            height: 60px;
            background-color: #ffffff;
            margin-left: 20px;
        }

        .idCard:first-child {
            margin-left: 0;
        }
    }

    #userDialog .dialog_text {
        width: @a;
        height: 60px;
        line-height: 60px;
        font-family: MicrosoftYaHei;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #aaaaaa;
    }

    #userDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        color: #fff;
        line-height: 80px;
        text-align: center;
    }

    #phoneDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        color: #fff;
        line-height: 80px;
        text-align: center;
        margin-top: 30px;
    }

    #phoneDialog .dialog_phone {
        width: @a;
        height: 23px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
    }

    #phoneDialog .dialog_code {
        width: auto;
        height: 60px;
        background-color: #fff;
        margin-top: 30px;
        position: relative;

        .btn {
            width: 150px;
            height: 60px;
            background-color: #f5f5f5;
            border: solid 1px #aaaaaa;
            font-family: MicrosoftYaHei;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            position: absolute;
            right: 0;
            bottom: 0;
            @row();
            cursor: pointer;

        }
    }

    .forget {
        width: @a;
        height: @a;

        .forget_all {
            width: @a;
            height: 700px;
            @row();

            .forget_accent {
                width: 760px;
                height: 620px;
                background-color: #fff;
                border-radius: 30px;
                border: solid 1px #aaaaaa;
                @column();

                .forget_title {
                    width: 160px;
                    height: 36px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #333333;
                }

                .forget_phone {
                    width: 520px;
                    height: 60px;
                    background-color: #fff;
                    margin-top: 43px;
                }

                .forget_code {
                    width: 520px;
                    height: 60px;
                    background-color: #fff;
                    margin-top: 30px;
                    position: relative;

                    .btn {
                        width: 150px;
                        height: 60px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        @row();
                        cursor: pointer;

                    }
                }

                .forget_pass {
                    width: 520px;
                    height: 60px;
                    background-color: #fff;
                    margin-top: 30px;
                }

                .aginBtn {
                    width: 520px;
                    height: 80px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                    text-align: center;
                    line-height: 80px;
                    margin-top: 30px;
                    cursor: pointer;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/page/login/forgetPass.vue